<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="位置尺寸" name="1"  v-if="request_prefix === 'bigScreen'">
      <widthAndSizeAndZindex :options="options" :ids="ids" />
    </el-collapse-item>
    <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
    <el-collapse-item title="外观" name="6">
      <p>横向倾斜度</p>
      <slider-and-input :value.sync="beta" suffix="度" :sliderMin="-80" :sliderMax="80"></slider-and-input>
      <p>纵向倾斜度</p>
      <slider-and-input :value.sync="alpha" suffix="度" :sliderMin="5" :sliderMax="90"></slider-and-input>
      <p>厚度</p>
      <slider-and-input :value.sync="regionHeight" suffix="度"></slider-and-input>
    </el-collapse-item>
    <el-collapse-item title="特效" name="2">
      <series-setting :options="options" />
    </el-collapse-item>
    <el-collapse-item title="全局配置" name="3">
      <global-setting :options="options" />
    </el-collapse-item>
    <el-collapse-item title="区域设置" name="4">
      <area-setting :options="options" />
    </el-collapse-item>
    <el-collapse-item title="区域标签" name="5">
      <area-label :options="options" />
    </el-collapse-item>
    <el-collapse-item
        v-show="$store.state.states.showPluginSetting"
        title="插件"
        name="7">
      <pluginSetting :options="options"/>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex"
import globalSetting from "./mapSettings/globalSetting"
import seriesSetting from "./mapSettings/seriesSetting.vue"
import areaSetting from "./mapSettings/areaSetting"
import areaLabel from "../../map/toolbars/mapSettings/areaLabel"
import pluginSetting from "../../map/toolbars/mapSettings/pluginSetting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
export default {
  name: "map3DOptionsSetting",
  components: {
    widthAndSizeAndZindex,
    seriesSetting,
    globalSetting,
    areaSetting,
    areaLabel,
    pluginSetting,
    ChartCommonOptionsSetting1,
  },
  props: {
    options: Object
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5", "6", "7"]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    regionHeight: {
      get() {
        return this.options.chartOption.geo3D.regionHeight
      },
      set(newValue) {
        this.$changeOptionsEV(newValue, "chartOption.geo3D.regionHeight", false)
      }
    },
    alpha: {
      get() {
        return this.options.chartOption.geo3D.viewControl.alpha
      },
      set(newValue) {
        this.$changeOptionsEV(newValue, "chartOption.geo3D.viewControl.alpha", false)
      }
    },
    beta: {
      get() {
        return this.options.chartOption.geo3D.viewControl.beta
      },
      set(newValue) {
        this.$changeOptionsEV(newValue, "chartOption.geo3D.viewControl.beta", false)
      }
    },
    distance: {
      get() {
        return this.options.chartOption.geo3D.viewControl.distance
      },
      set(newValue) {
        this.$changeOptionsEV(newValue, "chartOption.geo3D.viewControl.distance", false)
      }
    }
  }
}
</script>
